import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { PrivacyPolicy } from "../components/privacy-policy"

const PrivacyPolicyPage = () => (
  <Layout>
    <SEO title="Privacy Policy" />
    <PrivacyPolicy />
  </Layout>
)

export default PrivacyPolicyPage
